import axios from 'axios'

const request = axios.create({
    baseURL: `https://www.szce.com/api`,
    // baseURL: `https://www.szce.com:11000`,
    // baseURL:`localhost:8081`,
    withCredentials: true, 
    timeout: 30000
})


// request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    // config.headers['Content-Type'] = 'application/json;charset=utf-8';
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    let user = localStorage.getItem("token") ? localStorage.getItem("token") : null
    if (user) {
        
        config.headers['Authorization'] = user;  // 设置请求头
    }

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        // 当权限验证不通过的时候给出提示
        if (res.code === '401') {
            // ElementUI.Message({
            //     message: res.msg,
            //     type: 'error'
            // });
            // router.push("/login")
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)


export default request




// WEBPACK FOOTER //
// ./src/utils/request.js